//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchCreate, fetchUpdate, fetchDetail } from '@/api/PMS/baseInformation/manageArea';
export default {
  data: function data() {
    return {
      rules: {
        areaName: [{
          required: true,
          message: '请输入小区名称名称',
          trigger: 'change'
        }],
        areaOrder: [{
          required: true,
          message: '请输入序号',
          trigger: 'change'
        }],
        areaAddr: [{
          required: true,
          message: '请输入地址',
          trigger: 'change'
        }],
        areaPhone: [{
          required: true,
          message: '请输入电话',
          trigger: 'change'
        }]
      },
      childData: {}
    };
  },
  props: ['keyValue', 'showDialog'],
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.$nextTick(function () {
        _this.$refs['dataForm'].clearValidate();
      });

      if (this.keyValue > 0) {
        var queryData = {
          id: this.keyValue
        };
        fetchDetail(queryData).then(function (response) {
          _this.childData = response.data.data;
          delete _this.childData.opDate;
        });
      } else {
        this.childData = {};
      }
    },
    handCreate: function handCreate() {
      var _this2 = this;

      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          if (_this2.keyValue > 0) {
            fetchUpdate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'update'
              });
            });
          } else {
            fetchCreate(_this2.childData).then(function () {
              _this2.$emit('handCancle', true);

              _this2.Alert({
                alertType: 'add'
              });
            });
          }
        } else {
          _this2.Alert({
            alertType: 'valid'
          });
        }
      });
    },
    handCancle: function handCancle() {
      this.$emit('handCancle', false);
    }
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.$refs.dataForm.resetFields();
        this.init();
      }
    }
  }
};